import { c as _c } from "react/compiler-runtime";
import { Field } from 'react-final-form';
import { FIELD_SORT, SearchFormValuesGCSS } from './hooks/useGcssSearch';
import { SelectInput } from '@/components/inputs';
import { useTranslation } from 'react-i18next';
interface Props {
  initialValues?: Partial<SearchFormValuesGCSS>;
}
export function PriceOrder(props) {
  const $ = _c(5);
  const {
    initialValues
  } = props;
  const {
    t
  } = useTranslation("gcss");
  const t0 = initialValues?.[FIELD_SORT];
  let t1;
  if ($[0] !== t) {
    t1 = fieldRenderProps => <SelectInput {...fieldRenderProps} label={t("form.sort.label")} hideLabel={true} options={[{
      label: t("form.sort.favorite"),
      value: undefined satisfies SearchFormValuesGCSS['sort']
    }, {
      label: t("form.sort.lowPrice"),
      value: "priceAmount" satisfies SearchFormValuesGCSS['sort']
    }, {
      label: t("form.sort.highPrice"),
      value: "-priceAmount" satisfies SearchFormValuesGCSS['sort']
    }]} />;
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = <section><Field name={FIELD_SORT} initialValue={t0}>{t1}</Field></section>;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}